<template>
  <modal name="modal-schedule" :width="640">
    <p slot="header">
      {{ $t('Shipping') }}
    </p>
    <div slot="content">
      <div class="row center-xs" v-if="currentPartner && currentPartner.hasOwnProperty('schedule')">
        <section class="col-md-12 col-xs-12" v-if="currentPartner.schedule.delivery_conditions">
          <h1 class="align-center cl-accent col-xs-12 h3">
            {{ $t('Delivery price') }}
          </h1>
          <div class="row center-xs px15 delivery_conditions" v-html="currentPartner.schedule.delivery_conditions" />
        </section>
        <delivery-windows class="data-picker-modal" :store="currentPartner" />
        <delivery-windows-pickup class="data-picker-modal" v-if="currentPartnerCode === 'novus'" />
      </div>
      <h3 v-if="currentPartnerCode === 'novus'" class="align-center">
        &nbsp;Умови доставки
      </h3>
      <div v-if="currentPartnerCode === 'novus'" class="row center-xs px15">
        <ul class="col-xs-12 col-md-12 light weight-300 start-xs">
          <li class="mb10">
            Об'ємні одиниці товару, наприклад: кошик 50л., карнизи для ванни, санчата - доставляються на індивідуальних умовах.
          </li>
          <li class="mb10">
            При замовленні більше, ніж 50 одиниць одного й того самого товару, з Вами обов'язково зв'яжуться для уточнення його наявності та механізму оплати: якщо в супермаркеті не буде необхідної кількості товару й потрібна буде спеціальна поставка, треба буде зробити передоплату.
          </li>
          <li class="mb10">
            При замовленні товарів підакцизної групи (алкоголь, тютюн) на суму від 9000 грн з Вами обов'язково зв'яжуться для уточнення його наявності та механізму оплати: для резерву товару та спеціальної доставки необхідно буде внести 50% передоплату.
          </li>
          <li class="mb10">
            Вам потрібно зробити декілька окремих замовлень (на різні чеки), але Ви хочете, щоб вони були об'єднані в одну доставку: при оформленні доставки, що складається з декількох, але не більше трьох, замовлень на одну адресу, на одне вікно доставки та з одного магазину -  вартість доставки буде розраховуватись як для одного замовлення, що також включає в себе сукупну вагу по усім замовленням. Якщо Вам необхідно буде оформити доставку, що складається з чотирьох і більше замовлень, то вартість доставки буде збільшуватися на 10 грн. за кожне наступне замовлення, а перерахунок вартості ваги буде здійснюватись відповідно до тарифів зазначених вище.
          </li>
          <li class="mb10">
            Служба доставки залишає за собою право відмінити замовлення у випадку неможливості його доставки (паводки, землетруси, катаклізми, складна транспортна ситуація у місті, або якщо адреса пункту доставки знаходиться в зоні, до якої неможливо під'їхати на автомобілі. У випадку відміни замовлення, Клієнт може самостійно повторити замовлення на сайті.
          </li>
          <li class="mb10">
            Ми залишаємо за собою право проводити інформування Клієнтів про відміну замовлень шляхом смс-повідомлення (максимум за 2 години до кінця обраного вікна доставки).
          </li>
        </ul>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "../../../Modal";
import DeliveryWindows from "../../../../theme/blocks/Home/DeliveryWindows";
import DeliveryWindowsPickup from "../../../../theme/blocks/Home/DeliveryWindowsPickup";
import { mapGetters } from 'vuex'
export default {
  name: "ScheduleModal",
  components: {
    Modal,
    DeliveryWindows,
    DeliveryWindowsPickup
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner',
      currentPartnerCode: 'partners/getCurrentPartnerCode'
    })
  }
}
</script>

<style scoped>
.delivery_conditions >>> ul {
  text-align: left;
  list-style: none;
  font-family: 'TTNorms Light', sans-serif;
  width: 100%!important;
}
.delivery_conditions >>> li {
  font-size: 14px;
  padding-left: 7px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.delivery_conditions >>> li::before {
  content: "";
  background-color: #11bb2e;
  display: inline-block;
  font-size: 35px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -14px;
  margin-right: 5px;
  margin-bottom: 2px;
}
.bold{
  font-family: 'TTNorms Bold', sans-serif;
}

</style>
<style lang="scss">
  .data-picker-modal {
    .date-picker-elem {
      a {
        @media (max-width: 400px) {
          padding: 10px 5px;
        }
      }
    }
  }
</style>

